import script from "./TraitShopCart.vue?vue&type=script&setup=true&lang=js"
export * from "./TraitShopCart.vue?vue&type=script&setup=true&lang=js"

import "./TraitShopCart.vue?vue&type=style&index=0&id=49c7705c&lang=scss"

const __exports__ = script;

export default __exports__